import React, { useState, useEffect } from 'react';
import './DailyLog.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function DailyLog({ onBack, user }) {
    const [logData, setLogData] = useState({
    knock: 0,
    call: 0,
    email: 0,
    opp_created: 0,
    appt_set: 0,
    appt_attended: 0,
    proposals_delivered: 0,
    sale: 0,
    ac_partner: 0,
    networking_event: 0,
    motis_appointment: 0,
    rsc_observation: 0,
    rsa_observation: 0,
    team_huddle: 0,
  });

  const [totalPoints, setTotalPoints] = useState(0);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const fieldLabels = {
    knock: 'Knock (2 pts)',
    call: 'Call (1 pt)',
    email: 'Email (1 pt)',
    opp_created: 'Opportunity Created (2 pts)',
    appt_set: 'Appointment Set (5 pts)',
    appt_attended: 'Appointment Attended (5 pts)',
    proposals_delivered: 'Proposals Delivered (10 pts)',
    sale: 'Sale (20 pts)',
    ac_partner: 'AC Partner (5 pts)',
    networking_event: 'Networking Event (5 pts)',
    motis_appointment: 'MOTIS Appointment (10 pts)',
    rsc_observation: 'RSC Observation - R2BAE Only (5 pts)',
    rsa_observation: 'RSA Observation - R2BAE Only (5 pts)',
    team_huddle: 'Team Huddle - R2BAE Only (10 pts)',
  };

  const pointValues = {
    knock: 2, call: 1, email: 1, opp_created: 2,
    appt_set: 5, appt_attended: 5, proposals_delivered: 10,
    sale: 20, ac_partner: 5, networking_event: 5, motis_appointment: 10,
    rsc_observation: 5, rsa_observation: 5, team_huddle: 10,
  };

  useEffect(() => {
    fetchTodayLog();
  }, []);

  useEffect(() => {
    calculateTotalPoints();
  }, [logData]);

  const fetchTodayLog = async () => {
    try {
      const response = await fetch(`${API_URL}/api/today/`, {
        headers: {
          'X-User-ID': user.userId,
        },
      });
      if (response.ok) {
        const data = await response.json();
        const logFields = { ...logData };
        Object.keys(logFields).forEach(key => {
          logFields[key] = data[key] || 0;
        });
        setLogData(logFields);
      }
    } catch (error) {
      console.error('Error fetching today\'s log:', error);
      setMessage('Error loading today\'s log');
    } finally {
      setLoading(false);
    }
  };

  const calculateTotalPoints = () => {
    let total = 0;
    Object.keys(logData).forEach(key => {
      total += (parseInt(logData[key]) || 0) * pointValues[key];
    });
    setTotalPoints(total);
  };

  const incrementField = (fieldName) => {
    setLogData(prev => ({
      ...prev,
      [fieldName]: prev[fieldName] + 1
    }));
  };

  const decrementField = (fieldName) => {
    setLogData(prev => ({
      ...prev,
      [fieldName]: Math.max(0, prev[fieldName] - 1)
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');

    try {
      const response = await fetch(`${API_URL}/api/today/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-User-ID': user.userId,
        },
        body: JSON.stringify(logData),
      });

      if (response.ok) {
        setMessage('Log saved successfully!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage('Error saving log. Please try again.');
      }
    } catch (error) {
      console.error('Error saving log:', error);
      setMessage('Error saving log. Please check your connection.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading today's log...</div>;
  }

  return (
    <div className="daily-log">
      <div className="header">
        <button onClick={onBack} className="back-button">&#8592; Back to Menu</button>
        <h2>Daily Log - {new Date().toLocaleDateString()}</h2>
      </div>

      <div className="form-container">
        {Object.keys(fieldLabels).map(key => (
          <div key={key} className="form-field">
            <label>{fieldLabels[key]}</label>
            <div className="counter-controls">
              <button
                onClick={() => decrementField(key)}
                className="counter-button decrement"
                disabled={logData[key] === 0}
              >
                -
              </button>
              <span className="counter-value">{logData[key]}</span>
              <button
                onClick={() => incrementField(key)}
                className="counter-button increment"
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="total-points">
        <h3>Total Points: {totalPoints}</h3>
      </div>

      <div className="actions">
        <button
          onClick={handleSave}
          className="save-button"
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save Log'}
        </button>
      </div>

      {message && <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>
        {message}
      </div>}
    </div>
  );
}

export default DailyLog;
